// extracted by mini-css-extract-plugin
module.exports =  {"img":"_6c97079b1b--img--Shiy6","letter-img":"_6c97079b1b--letter-img--_ER5E","circle":"_6c97079b1b--circle--u4Haq"};